import { HttpErrorResponse } from '@angular/common/http';
import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';

import {
    PaymentProfile,
    PaymentProfileCreateRequest,
    PaymentProfileEditRequest,
    PaymentProfileListItem,
    PaymentProfilesListResponse,
    PaymentProfileStatus
} from '../../entities';

import { ProfilesPageParams } from './profiles.model';

const actionFeatureKey = 'Payment Profiles';

export const loadPaymentProfiles = createAction(
    `[${actionFeatureKey}/API] Load Payment Profiles`,
    props<{ pageParams: ProfilesPageParams }>()
);
export const loadPaymentProfilesSuccess = createAction(
    `[${actionFeatureKey}/API] Load Payment Profiles Success`,
    props<{ response: PaymentProfilesListResponse }>()
);
export const loadPaymentProfilesFailure = createAction(
    `[${actionFeatureKey}/API] Load Payment Profiles Failure`,
    props<{ loadError: HttpErrorResponse }>()
);

export const setPageParams = createAction(
    `[${actionFeatureKey}] Set Page Params`,
    props<{ pageParams: ProfilesPageParams }>()
);

export const deleteProfile = createAction(`[${actionFeatureKey}/API] Delete Profile`, props<{ id: number }>());
export const deleteProfileSuccess = createAction(
    `[${actionFeatureKey}/API] Delete Profile Success`,
    props<{ id: number }>()
);
export const deleteProfileFailure = createAction(
    `[${actionFeatureKey}/API] Delete Profile Failure`,
    props<{ id: number; error: HttpErrorResponse }>()
);

export const changeProfileStatus = createAction(
    `[${actionFeatureKey}/API] Change Profile Status`,
    props<{ id: number; status: PaymentProfileStatus }>()
);
export const changeProfileStatusSuccess = createAction(
    `[${actionFeatureKey}/API] Change Profile Status Success`,
    props<Update<PaymentProfileListItem>>()
);
export const changeProfileStatusFailure = createAction(
    `[${actionFeatureKey}/API] Change Profile Status Failure`,
    props<{ id: number; error: HttpErrorResponse }>()
);

export const createProfile = createAction(
    `[${actionFeatureKey}/API] Create Profile`,
    props<{ profile: PaymentProfileCreateRequest }>()
);
export const createProfileSuccess = createAction(
    `[${actionFeatureKey}/API] Create Profile Success`,
    props<{ profile: PaymentProfile }>()
);
export const createProfileFailure = createAction(
    `[${actionFeatureKey}/API] Create Profile Failure`,
    props<{ error: HttpErrorResponse }>()
);

export const editProfile = createAction(
    `[${actionFeatureKey}/API] Edit Profile]`,
    props<{ profile: PaymentProfileEditRequest }>()
);
export const editProfileSuccess = createAction(
    `[${actionFeatureKey}/API] Edit Profile Success]`,
    props<{ profile: PaymentProfile }>()
);
export const editProfileFailure = createAction(
    `[${actionFeatureKey}/API] Edit Profile Failure]`,
    props<{ error: HttpErrorResponse }>()
);
